import script from "./LoginModel.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginModel.vue?vue&type=script&setup=true&lang=js"

import "./LoginModel.vue?vue&type=style&index=0&id=8729d0f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8729d0f4"]])

export default __exports__